import type { Conditions, Item, PROMOTION_TYPE, Restrictions } from 'typings'
import { SCOPE_OPTIONS } from '../Form/ItemsView/typing'
import { Gift } from './gift'
import type { PromotionBase } from './promotion'
import { BuyAndWinFreeShipping } from './shipping'

export enum BuyAndWinBenefitVariant {
  GIFT = 'gift',
  FREE_SHIPPING = 'freeShipping',
  MAXIMUM_UNIT_PRICE_DISCOUNT = 'maximumUnitPriceDiscount',
}

export enum MaxPriceKeys {
  price = 'price',
}

export type BuyAndWinGift = Gift<BuyAndWinBenefitVariant.GIFT>

export enum ShippingApplyTo {
  all = 'all',
  cheapest = 'cheapest',
  selected = 'selected',
}

export enum ShippingKeys {
  applyTo = 'applyTo',
  selectedMethods = 'selectedMethods',
}

export type MaximumUnitPriceDiscount = {
  type: BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT
  [MaxPriceKeys.price]: number
}

export type BuyAndWinTrigger = {
  [SCOPE_OPTIONS.COLLECTIONS]: Item[]
  [SCOPE_OPTIONS.SKUS]: Item[]
  minQuantity: number
  sameItemsOnly: boolean
}

export type BuyAndWinBenefit =
  | BuyAndWinFreeShipping
  | BuyAndWinGift
  | MaximumUnitPriceDiscount

export enum BuyAndWindEffectKeys {
  TRIGGER = 'trigger',
  BENEFIT = 'benefit',
}
export interface BuyAndWinEffect {
  [BuyAndWindEffectKeys.TRIGGER]: BuyAndWinTrigger | undefined
  [BuyAndWindEffectKeys.BENEFIT]: BuyAndWinBenefit | undefined
}

export type BuyAndWinRestrictions = Omit<
  Restrictions,
  'maxItemsPerAttribute' | 'maxItemsPerCart' | 'accumulateWithManualPrices'
>

export interface BuyAndWinPromotion extends PromotionBase {
  type: PROMOTION_TYPE.BUY_AND_WIN
  buyAndWin: BuyAndWinEffect
  conditions: Conditions
  restrictions: BuyAndWinRestrictions
}
